import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { WatchOnTvSheet } from './WatchOnTv.jsx';
import { StudioMark } from '../lib/branding.jsx';
import { IconDownload } from '../lib/icons.jsx';

/**
 * Solid top bar shared by the Film and Photos pages. The studio mark returns to
 * the cover; the segmented control moves between the two content pages (only
 * showing a destination that actually has content). The cover page draws its own
 * transparent bar over the hero, so it doesn't use this.
 */
export default function GalleryBar({ slug, videos, photos, downloadsOn, onDownload, transparent }) {
  const [tvOpen, setTvOpen] = useState(false);
  return (
    <header className={`gal-bar ${transparent ? '' : 'solid'}`}>
      <Link to={`/${slug}`} className="bar-mark" aria-label="Back to cover">
        <StudioMark />
      </Link>

      <div className="row" style={{ gap: '0.5rem' }}>
        {videos.length > 0 && photos.length > 0 && (
          <nav className="segmented" aria-label="Sections">
            <NavLink to={`/${slug}/film`} className={({ isActive }) => (isActive ? 'is-active' : '')}>
              Film
            </NavLink>
            <NavLink to={`/${slug}/photos`} className={({ isActive }) => (isActive ? 'is-active' : '')}>
              Photos
            </NavLink>
          </nav>
        )}
        <button className="ghost sm" onClick={() => setTvOpen(true)} title="Show this gallery on your TV">
          <span>Watch on TV</span>
        </button>
        {downloadsOn && (
          <button className="primary sm" onClick={onDownload}>
            <IconDownload width={15} height={15} />
            <span className="hide-sm">Download</span>
          </button>
        )}
      </div>
      {tvOpen && <WatchOnTvSheet slug={slug} onClose={() => setTvOpen(false)} />}
    </header>
  );
}
